// @ts-nocheck
export const SETUP_EMAIL_REDIRECTION_PATH = "SETUP_EMAIL_REDIRECTION_PATH";

export const CLEAR_EMAIL_REDIRECTION_REDUCER =
  "CLEAR_EMAIL_REDIRECTION_REDUCER";

// fetch email data
export const FETCH_EMAIL_DATA_REQUEST = "FETCH_EMAIL_DATA_REQUEST";
export const FETCH_EMAIL_DATA_SUCCESS = "FETCH_EMAIL_DATA_SUCCESS";
export const FETCH_EMAIL_DATA_FAILURE = "FETCH_EMAIL_DATA_FAILURE";